import type { PointType } from './index';
import { GetUuid } from './createuuid'
import { getPlatform } from "../index";

let url = 'https://prod-sit-logserver.heytea.com/';

export function consumeDataList(list: PointType[]) {
  const data = JSON.stringify({
    version_type: 2,
    data_list: list,
  });
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  })
    .then((response) => {
      if (response.status === 200) {
        console.log('批量上报埋点数据成功 ==>', data);
      }
    })
    .catch((error: any) => {

    });
}

const Platform = getPlatform()

export const PointUtil = {
  pointEvent: (type: 'click' | 'show', eventId: string, data?: Record<string, any>) => {
    consumeDataList([{
      type: type,
      page: '',
      event_id: eventId,
      role_id: '',
      job_id: '',
      login_source: 'HeyteaStoreApp',
      uuid: GetUuid(),
      platform: Platform,
      os: Platform,
      access_time: Date.now(),
      app_version: 'heystore.heytea.com',
      device_brand: '',
      device_model: '',
      data: data,
    }])
  },
}
